module.exports = __webpack_public_path__ + "img/restaurant-banner-pc.0ab38512.jpg";